import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag } from "PFTypes";

const useIsChatEnabled = () => useIsFeatureEnabled(FeatureFlag.Chat);

export default useIsChatEnabled;
